import { render, staticRenderFns } from "./PapersCover.vue?vue&type=template&id=1e8a1bfd&scoped=true"
import script from "./PapersCover.vue?vue&type=script&lang=js"
export * from "./PapersCover.vue?vue&type=script&lang=js"
import style0 from "./PapersCover.vue?vue&type=style&index=0&id=1e8a1bfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8a1bfd",
  null
  
)

export default component.exports